export function jsonStringifyOnServer(object) {
    return typeof window === 'undefined'
        ? JSON.stringify(object, null, 2)
        : object;
}
